import { useState } from 'react'
import { MembersListPage } from '@/components/members/members-list-page'
import { CommitteeRoster } from '@/components/members/committee-roster'
import { PageHeader, PageShell } from '@/components/portal/page-header'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { InviteMemberModal } from '@/components/members/invite-member-modal'
import { useTabQueryParam } from '@/hooks/use-tab-query-param'
import { cn } from '@/lib/utils'

type Tab = 'all' | 'committee'
const VALID_TABS: Tab[] = ['all', 'committee']

export function AdminMembers() {
  const [tab, setTab] = useTabQueryParam(VALID_TABS, 'all')
  const [inviteOpen, setInviteOpen] = useState(false)

  return (
    <PageShell>
      <PageHeader
        title="Members"
        label="Management"
        description="Invite, manage, and view member accounts and plot assignments."
        action={
          <div className="flex flex-wrap gap-2">
            <Link
              to="/admin/members/import"
              className="inline-flex h-10 items-center justify-center rounded border border-border bg-transparent px-5 font-sans text-[13px] font-medium tracking-wide text-ink transition-colors hover:border-ink"
            >
              Import members
            </Link>
            <Button type="button" onClick={() => setInviteOpen(true)}>
              Invite member
            </Button>
          </div>
        }
      />

      <InviteMemberModal open={inviteOpen} onClose={() => setInviteOpen(false)} />

      {/* Tab switcher */}
      <div className="flex gap-1 border-b border-border-2">
        {(['all', 'committee'] as Tab[]).map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={cn(
              'px-4 py-2.5 font-sans text-sm font-medium transition-colors',
              tab === t
                ? 'border-b-2 border-primary text-ink'
                : 'text-muted-foreground hover:text-ink',
            )}
          >
            {t === 'all' ? 'All members' : 'Committee'}
          </button>
        ))}
      </div>

      {tab === 'all' && <MembersListPage basePath="/admin/members" showInvite={false} hideHeader />}

      {tab === 'committee' && <CommitteeRoster memberDetailBasePath="/admin/members" />}
    </PageShell>
  )
}
